import Phaser from 'phaser';
import { RacingLoadingScene, KilobaRacingScene } from './scenes';

export class KilobaRacingGame {
  private game: Phaser.Game;

  constructor(container: HTMLElement) {
    console.log(window.innerHeight)
    console.log(window.innerWidth)
    const config: Phaser.Types.Core.GameConfig = {
      type: Phaser.AUTO,
      width: window.innerWidth,
      height: window.innerHeight,
      parent: container,
      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: 1080,
        height: 1920
      },
      render: {
        antialias: true,
        antialiasGL: true,
        mipmapFilter: 'LINEAR_MIPMAP_LINEAR',
        roundPixels: false,
        pixelArt: false,
        powerPreference: 'high-performance'
      },
      physics: {
        default: 'arcade',
        arcade: {
          gravity: { y: 0, x: 0 },
          debug: false
        }
      },
      scene: [RacingLoadingScene, KilobaRacingScene]
    };

    this.game = new Phaser.Game(config);
  }

  destroy(): void {
    if (this.game) {
      this.game.destroy(true);
    }
  }
}
